import React from 'react';
import PrimaryButton from '../../../view/common/component/PrimaryButton';

export default function ExistingUserPage3({
    parentEmail,
    onSubmit,
    isNewUser
}) {
    const timeToDeletion = isNewUser ? '72 hours' : '14 days';

    return (
        <div data-testid="existing-user-page-3">
            <h4 className="terms-of-use-title">
                Parent or legal guardian consent request has been sent
            </h4>
            <div className="paragraph-padding">
                <p>{`Email has been sent to ${parentEmail}.`}</p>
                <p>
                    {`If consent is not granted within ${timeToDeletion}, your account will be deleted.`}
                </p>
            </div>
            <PrimaryButton
                onClick={onSubmit}
                showActivity={false}
                className="wide-button"
                testid="page-3"
            >
                Got It
            </PrimaryButton>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/v5/termsOfUse/components/ExistingUserPage3.js